import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import DataTable from "../../lib/DataTable";
import { Modal, Notice } from "../../lib/ui";

/* Active sessions – port of active_sessions.php (API: /api/sessions, backend/admin.py). Terminating a session needs an admin. */

const fmt = (s) => (s ? new Date(s.replace(" ", "T")).toLocaleString("en-GB") : "–");

export default function ActiveSessions() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [notice, setNotice] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const load = useCallback(async () => {
    try { setRows(await api.get("/api/sessions")); } catch (e) { setNotice({ tone: "err", text: e.message }); }
  }, [api]);
  useEffect(() => { load(); }, [load]);

  const terminate = async () => {
    const t = confirm.token;
    setConfirm(null);
    try { const r = await api.request(`/api/sessions/${encodeURIComponent(t)}`, "DELETE"); setNotice({ tone: r.success ? "ok" : "warn", text: r.message }); load(); }
    catch (e) { setNotice({ tone: "err", text: e.message }); }
  };

  const columns = [
    { key: "token", label: "Session token", render: (r) => <span className="mono" style={{ fontSize: ".75rem" }}>{r.token}</span> },
    { key: "user_id", label: "User ID", num: true },
    { key: "username", label: "Username", render: (r) => <b style={{ color: "var(--ink)" }}>{r.username}</b> },
    { key: "last_active", label: "Last active", render: (r) => fmt(r.last_active) },
    { key: "expires_at", label: "Expires", render: (r) => fmt(r.expires_at) },
    { key: "action", label: "", sortable: false, render: (r) => <button type="button" className="btn sm" onClick={() => setConfirm(r)}>Terminate</button> },
  ];

  return (
    <main className="pg">
      <PageHeader slug="active_sessions" actions={<button type="button" className="btn" onClick={load}><i className="fas fa-rotate-right" /> Refresh</button>} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <section className="panel">
        {rows ? <DataTable columns={columns} rows={rows} rowKey={(r) => r.token} searchPlaceholder="Search sessions" initialSort={{ key: "last_active", dir: -1 }} empty="No active sessions found." />
          : <div className="empty"><i className="fas fa-spinner fa-spin" />Loading sessions…</div>}
      </section>
      {confirm && (
        <Modal title="Terminate session?" onClose={() => setConfirm(null)}
          actions={<><button type="button" className="btn" onClick={() => setConfirm(null)}>Cancel</button><button type="button" className="btn danger" onClick={terminate}>Terminate</button></>}>
          <b>{confirm.username}</b> (user {confirm.user_id}) will be signed out on that device.
        </Modal>
      )}
    </main>
  );
}
